import './snackbar.css';

import { CircularProgress, Snackbar } from '@material-ui/core';
import BindingMixin from 'bz-core-controls/mixins//binding-mixin';
import createReactClass from 'create-react-class';
import React from 'react';

export default createReactClass({
  displayName: 'auto-save-snackbar',
  mixins: [BindingMixin],

  getInitialState() {
    return { snackOpen: true };
  },

  getDefaultProps() {
    return {
      saving: false,
      saved: false
    };
  },

  UNSAFE_componentWillReceiveProps(next) {
    return this.setState(next);
  },

  hide() {
    return this.setState({ snackOpen: false });
  },

  render() {
    let message = (
      <div>
        <span className="text">{'Saving '}</span>
        <div className="spinner">
          <CircularProgress mode="indeterminate" />
        </div>
      </div>
    );

    if (this.props.saved) {
      message = (
        <div>
          <span className="text">Saved</span>
        </div>
      );
    }

    return (
      <div className={this.props.className + ' snackbar'} style={this.props.style}>
        {this.props.saving ? (
          <Snackbar
            style={{ paddingBottom: '75px' }}
            open={this.state.snackOpen || false}
            message={message}
            onClose={this.hide}
          />
        ) : undefined}
      </div>
    );
  }
});
